// extracted by mini-css-extract-plugin
export default {"link":"EK-z","disabled":"FK-z"};